const ACCOUNT_PATH = /^(?:\/prototype\/vnext)?\/(?:account\/[^/]+|settings\/[^/]+|billing\/[^/]+|team(?:\/(?:settings|members|usage))?)\/?$/;
const WORKSPACE_PATH = /^(?:\/prototype\/vnext)?\/(?:home|writing|canvas|assets|templates|learn|help|scripts|creative-agent)(?:\/.*)?$/;

export function isAccountPath(pathname) {
  return ACCOUNT_PATH.test(pathname || '');
}

export function initialAccountRoute(location) {
  return { location, background: null, depth: 0, entries: {} };
}

// Keep the real workspace location (including its key, query and route state).
// POP uses remembered entries so Back/Forward behave like normal navigation.
export function advanceAccountRoute(previous, location, navigationType, signedIn) {
  const result = { ...previous, location, background: null, depth: 0 };
  if (!isAccountPath(location.pathname)
    || (!signedIn && !location.pathname.startsWith('/prototype/vnext/'))) return result;
  const remembered = navigationType === 'POP' && previous.entries[location.key];
  if (remembered) return { ...result, ...remembered };
  if (navigationType === 'POP') return result;
  const background = previous.background || (
    WORKSPACE_PATH.test(previous.location.pathname) || previous.location.pathname === '/prototype/vnext'
      ? previous.location : null
  );
  if (!background) return result;
  const depth = previous.depth + (navigationType === 'PUSH' ? 1 : 0);
  return {
    ...result, background, depth,
    entries: { ...previous.entries, [location.key]: { background, depth } },
  };
}

export function accountOverlayIsOpen() {
  return typeof document !== 'undefined' && !!document.querySelector('[data-account-center-layer]');
}
